import { Container } from '@geberit/gdds';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

// styles
import styles from './breadcrumb.module.scss';

// components
import { Icon } from 'components/Icon/Icon';
import Breadcrumb from 'components/Breadcrumb/Breadcrumb'

// utils
import useShowBreadcrumbs from 'utils/hooks/use-show-breadcrumbs';
import { buildSize, gridSizes } from 'utils/gridSize';
import { useXy } from 'utils/hooks/use-xy';

export default function CheckoutBreadcrumb({ item = '' }: Readonly<{ item?: string }>) {
  const showBreadcrumbs = useShowBreadcrumbs();
  const pathname = usePathname();
  const isXy = useXy();

  const gddsBreadItem = [
    {
      breadcrumbDisabled: false,
      label: '',
      url: '/'
    }, {
      breadcrumbDisabled: false,
      label: item,
      url: pathname
    }
  ];

  if (!showBreadcrumbs) return null;

  return (
    <>
      {isXy ? (
        <Breadcrumb items={gddsBreadItem} />
      ):(
        <Container className={styles.c_breadcrumb} maxContentWidth={buildSize(gridSizes.countryGrid)}>
          <ol>
            <li className={styles.c_breadcrumb__item}>
              <div className={styles.c_breadcrumb__item__home}>
                <Link href="/">
                  <Icon symbol="breadcrumb-home" />
                </Link>
              </div>
            </li>
            <li className={styles.c_breadcrumb__item}>
              <Link href={pathname}>{item}</Link>
            </li>
          </ol>
        </Container>
      )}
    </>
  );
}
